<template>
    <div>
    <sweet-modal blocking :title="$t('modal_createEngagementTaskProgress')" width="780px" ref="createEngagementTaskProgress" class="modal" v-on:close="closeModal">
        <el-form label-position="left" :model="formcreateEngagementTaskProgress" status-icon :rules="rules" ref="formcreateEngagementTaskProgress" label-width="100px" class="demo-ruleForm">

            <template v-if="parentBill">
                <el-form-item label-width="0">
                    <el-switch v-model="formcreateEngagementTaskProgress.isBillable" :active-text="$t('modal_billing')"></el-switch>
                </el-form-item>

                <el-row v-if="formcreateEngagementTaskProgress.isBillable" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="assignmentsId" label-width="0">
                            <el-select v-model="formcreateEngagementTaskProgress.assignmentsId" :placeholder="$t('modal_assignments')" clearable style="width: 100%;">
                            <el-option v-for="item in formcreateEngagementTaskProgress.assignments"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                @click.native="selectAssignments(item)">
                            </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="activitiesId" label-width="0">
                            <el-select v-model="formcreateEngagementTaskProgress.activitiesId" :placeholder="$t('modal_activities')" clearable style="width: 100%;">
                            <el-option v-for="item in formcreateEngagementTaskProgress.activities"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row v-if="formcreateEngagementTaskProgress.isBillable">
                    <el-col :span="24">
                    <el-form-item label-width="0" prop="title">
                        <el-input v-model="formcreateEngagementTaskProgress.title" :label="$t('modal_shortNote')"></el-input>
                    </el-form-item>
                    </el-col>
                </el-row>
            </template>

            <!--{{formcreateEngagementTaskProgress}}-->
            <el-form-item class="text-block" label-position="top" label-width="0">
                <vue2-custom-editor
                    ref="editor"
                    style="margin-bottom: 20px;"
                    v-model="formcreateEngagementTaskProgress.text"/>

                <!--<el-input type="textarea" placeholder="Text" v-model="formcreateEngagementTaskProgress.text"></el-input>-->
            </el-form-item>
            <!--{{selectedRow}}-->
            <div class="reminder-block">
                <el-form-item :label="$t('modal_timeSpent')">
                    <el-time-picker
                        v-model="formcreateEngagementTaskProgress.timeSpent"
                        value-format='HHmm'
                        format='HH:mm'
                        :picker-options="{
                            align: 'center'
                        }"
                        placeholder="Arbitrary time">
                    </el-time-picker>
                </el-form-item>
                <div class="reminder-block_date">
                    <el-form-item prop="isReminderActive" :label="$t('modal_setReminder')" label-width="1ц0px">
                        <el-checkbox name="type" @change="isReminderActiveChange(formcreateEngagementTaskProgress.isReminderActive)" v-model="formcreateEngagementTaskProgress.isReminderActive"></el-checkbox>
                    </el-form-item>
                    <el-form-item prop="reminderDate" label-width="20px">
                        <el-date-picker
                                format="d MMM yy h : mm A"
                                :disabled="!formcreateEngagementTaskProgress.isReminderActive"
                                v-model="formcreateEngagementTaskProgress.reminderDate"
                                type="datetime"
                                :placeholder="$t('modal_pickADate')"
                                value-format="timestamp"
                        >
                        </el-date-picker>
                    </el-form-item>
                </div>
                <!--<el-button slot="trigger" v-on:click="$refs.formReminder.open()" size="small" type="primary">Set Reminder</el-button>-->
            </div>
            <!--<div class="remider">-->
                <!--<el-button slot="trigger" v-on:click="$refs.formReminder.open()" size="small" type="primary">Set Reminder</el-button>-->
            <!--</div>-->
            <!-- <div class="upload-media">
                <el-upload
                        class="upload-demo"
                        ref="upload"
                        action=""
                        :auto-upload="false"
                        :file-list="fileList">
                    <el-button slot="trigger" size="small" type="primary">Add Media</el-button>
                </el-upload>
            </div> -->
            <el-form-item :label="$t('modal_progress')" prop="Progress" >
                <el-slider
                        v-model="formcreateEngagementTaskProgress.progress"
                        :max="100"
                        :min="0"
                        :step="5"
                        show-stops>
                </el-slider>
            </el-form-item>

            <!-- <el-form-item label="Hours spent">
                <el-input placeholder="Hours spent" v-model="formcreateEngagementTaskProgress.hoursSpent"></el-input>
            </el-form-item>
            <el-form-item label="Minutes spent">
                <el-input placeholder="Minutes spent" v-model="formcreateEngagementTaskProgress.minutesSpent"></el-input>
            </el-form-item> -->
            <div class="flex-twocolumn">
                <el-form-item label-width="0">
                    <el-switch v-model="formcreateEngagementTaskProgress.notifyEngagementTeam"></el-switch> {{$t('modal_notifyEngagementTeam')}}
                </el-form-item>
                <el-form-item label-width="0">
                    <el-switch v-model="formcreateEngagementTaskProgress.notifyTaskTeam"></el-switch> {{$t('modal_notifyTaskTeam')}}
                </el-form-item>
                <el-form-item label-width="0">
                    <el-switch :disabled="allowNotification || !engagementPermission.addProgressNotifyClients" v-model="formcreateEngagementTaskProgress.notifyClients"></el-switch> {{$t('modal_notifyClients')}}
                </el-form-item>
                <el-form-item label-width="0">
                    <el-switch :disabled="allowNotification || !engagementPermission.addProgressNotifyVendors" v-model="formcreateEngagementTaskProgress.notifyVendors"></el-switch> {{$t('modal_notifyVendors')}}
                </el-form-item>
            </div>
            <div class="flex-end">
                <el-form-item  class="modal__btn">
                    <el-button @click="modalCancel('createEngagementTaskProgress')">{{$t('general_cancel')}}</el-button>
                    <el-button @click="createEngagementTaskProgressSubmit('formcreateEngagementTaskProgress')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </div>
        </el-form>
        <!--{{formcreateEngagementTaskProgress}}-->
    </sweet-modal>
    <!--<sweet-modal blocking  ref="formReminder" v-on:close="closeReminder">-->
        <!--<el-form :model="formReminder">-->
            <!--<el-form-item label="Set Reminder" label-width="120px" prop="date">-->
                <!--<el-date-picker-->
                        <!--v-model="formReminder.reminder"-->
                        <!--type="date"-->
                        <!--placeholder="Pick a date"-->
                        <!--value-format="ddMMyyyy"-->
                <!--&gt;-->
                <!--</el-date-picker>-->
            <!--</el-form-item>-->
            <!--<el-form-item>-->
                <!--<vue-editor v-model="formReminder.description"></vue-editor>-->
            <!--</el-form-item>-->
            <!--<el-form-item>-->
                <!--<el-button @click="setReminderSubmit" class="modal__btn" type="primary" plain size="medium">Set reminder</el-button>-->
            <!--</el-form-item>-->
        <!--</el-form>-->
    <!--</sweet-modal>-->
    </div>
</template>

<script>
    import Vue2CustomEditor from "../vue-2-custom-editor";
    import { SweetModal } from '@totalflow4/tfsweet-modal-vue';

    import axios from 'axios';

    export default {
        components: {
            SweetModal,
            Vue2CustomEditor,
        },
        props: [
          'selectedRow',
          'allowNotification',
          'engagementPermission',
          'parentBill',
          'assignmentList',
        ],
        mounted() {
          this.createEngagementTaskProgressOpen();
          this.formcreateEngagementTaskProgress.progress = this.selectedRow.progress
        },
        data() {
          var checkDate = (rule, value, callback) => {
            if (!value && this.formcreateEngagementTaskProgress.isReminderActive) {
              return callback(new Error('Please input the date'));
            }else callback();
          };
            return {
                engagementTaskId: 0,
                fileList:[],
                formcreateEngagementTaskProgress: {
                    isBillable: true,
                    activitiesId: null,
                    activities: [],
                    assignmentsId: null,
                    assignments: [],

                    title: '',
                    reminder:'',
                    progress: 0,
                    text: '',
                    timeSpent: '0000',
                    hoursSpent: 0,
                    minutesSpent: 0,
                    notifyProjectTeam: false,
                    notifyTaskTeam: true,
                    notifyClients: false,
                    notifyVendors: false,
                    isReminderActive: false,
                    reminderDate: '',
                    notifyEngagementTeam: false
                },
              rules: {
                reminderDate: [{ validator: checkDate, trigger: 'blur' }]
              }
                // formReminder:{
                //     reminder:'',
                //     description:''
                // },
            };
        },
        methods: {
            selectAssignments(item) {
                this.formcreateEngagementTaskProgress.activitiesId = null
                this.formcreateEngagementTaskProgress.activities = item.activities
            },
            modalCancel(ref) {
                this.$refs[ref].close();
            },
          isReminderActiveChange(value){
            if(!value){
              this.$refs['formcreateEngagementTaskProgress'].resetFields();
            }
          },
            closeModal() {
                this.formcreateEngagementTaskProgress.title = ''
                this.formcreateEngagementTaskProgress.text = ''
                this.formcreateEngagementTaskProgress.hoursSpent = 0
                this.formcreateEngagementTaskProgress.minutesSpent = 0
                this.formcreateEngagementTaskProgress.notifyProjectTeam = false
                this.formcreateEngagementTaskProgress.notifyTaskTeam = true
                this.formcreateEngagementTaskProgress.notifyClients = false
                this.formcreateEngagementTaskProgress.notifyVendors = false
                this.formcreateEngagementTaskProgress.reminderDate = ''
                this.formcreateEngagementTaskProgress.isReminderActive = false
                this.formcreateEngagementTaskProgress.timeSpent = '0000'
                this.formcreateEngagementTaskProgress.notifyEngagementTeam = false
                this.formcreateEngagementTaskProgress.isBillable = true
                this.formcreateEngagementTaskProgress.activitiesId = null
                this.formcreateEngagementTaskProgress.assignmentsId = null

            },
            notification(title, message, type) {
                this.$notify({
                    title: title,
                    message: message,
                    type: type,
                });
            },

            createEngagementTaskProgressOpen() {
            },

            createEngagementTaskProgressSubmit(form) {
              if(!this.formcreateEngagementTaskProgress.progress){
                return this.notification(this.$t('general_warning'), this.$t('modal_addProgressNote_progressCannotBeNull'), "info")
              }
              if(this.formcreateEngagementTaskProgress.progress < this.selectedRow.progress){
                return this.notification(this.$t('general_warning'), this.$t('modal_addProgressNote_progressCannotBeLess'), "info")
              }
                console.log('---', 'submit create');
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        let loader = this.$loading.show();

                        if (this.formcreateEngagementTaskProgress.timeSpent) {
                            let time, hours, minutes;
                            time = this.formcreateEngagementTaskProgress.timeSpent;
                            hours = time.slice(0, 2);
                            minutes = time.slice(2, 4);
                            this.formcreateEngagementTaskProgress.hoursSpent = hours
                            this.formcreateEngagementTaskProgress.minutesSpent = minutes
                        }
                      if(this.formcreateEngagementTaskProgress.reminderDate === ''){
                        this.formcreateEngagementTaskProgress.reminderDate = null
                      }
                      if (!this.formcreateEngagementTaskProgress.isBillable) {
                            this.formcreateEngagementTaskProgress.title = ''
                            this.formcreateEngagementTaskProgress.activitiesId = null
                            this.formcreateEngagementTaskProgress.assignmentsId = null
                        }
                        axios
                            .post(`/api/v1/engagementTaskProgresses/create?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.engagementTaskId}`,{
                                text: this.formcreateEngagementTaskProgress.text,
                                title: this.formcreateEngagementTaskProgress.title,
                                progress: this.formcreateEngagementTaskProgress.progress,
                                notifyEngagementTeam: this.formcreateEngagementTaskProgress.notifyEngagementTeam,
                                notifyTaskTeam: this.formcreateEngagementTaskProgress.notifyTaskTeam,
                                notifyClients: this.formcreateEngagementTaskProgress.notifyClients,
                                notifyVendors: this.formcreateEngagementTaskProgress.notifyVendors,
                                hoursSpent: this.formcreateEngagementTaskProgress.hoursSpent,
                                minutesSpent: this.formcreateEngagementTaskProgress.minutesSpent,
                                isReminderActive: this.formcreateEngagementTaskProgress.isReminderActive,
                                reminderDate: this.formcreateEngagementTaskProgress.reminderDate / 1000,
                                timer: false,
                                isBillable: this.parentBill ? this.formcreateEngagementTaskProgress.isBillable: false,
                                activityId: this.formcreateEngagementTaskProgress.activitiesId,
                                assignmentId: this.formcreateEngagementTaskProgress.assignmentsId,
                            })
                            .then(response => {
                                if (this.$refs.editor.uploadedImagesArray.length) {
                                    this.$store.dispatch('approveUploadedImages', {
                                    fileUrlArr: this.$refs.editor.uploadedImagesArray,
                                    entityId: response.data.engagementTaskProgressId,
                                    entityTypeId: 39 // eng progress
                                    })
                                }
                                // if (this.$refs.editor.removedImages.length) this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
                                this.$refs.createEngagementTaskProgress.close();
                                this.$store.dispatch('getEngagementProgressesList', this.engagementTaskId)
                                loader.hide()
                                this.notification(this.$t('general_success'), this.$t('modal_engagement_addProgressNote_createEngagementTaskProgress'), "success");
                                this.$emit('submit')
                            })
                            .catch(error => {
                                loader.hide()
                                // this.notification("Notification", error.response.data.message, "info")
                                //this.notification("Notification", "Invalid email value", "info");
                            });
                      if(this.formcreateEngagementTaskProgress.reminder.length){
                        axios
                          .post(`/api/v1/reminders/create`, {
                            date: this.formcreateEngagementTaskProgress.reminder,
                          })
                          .then(response => {
                            if(response.data.success){
                              console.log("reminder response", response.data)
                            }
                          })
                          .catch(error => {
                            loader.hide()
                            // this.notification("Notification", error.response.data.message, "info")
                          });
                      }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
          // closeReminder(){
          //   this.formReminder.description = ''
          //   this.formReminder.reminder = ''
          // },
          // setReminderSubmit(){
          //   console.log('SET REMINDER')
          //   axios
          //     .post(`/api/v1/reminders/create`, {
          //       date: this.formReminder.reminder,
          //       text: this.formReminder.description,
          //       entityType: localStorage.getItem('selectedProjectId'),
          //       entityId: this.selectedRow.id
          //     })
          //     .then(response => {
          //       if(response.data.success){
          //         this.$refs.formReminder.close();
          //         this.notification("Success", "Reminder successfully sent", "success");
          //         console.log("reminder response", response.data)
          //       }
          //     })
          //     .catch(error => {
          //       loader.hide()
          //       this.$refs.formReminder.close();
          //       this.notification("Notification", error.response.data.message, "info")
          //     });
          // },
          // close(){
          //     alert("hEEELOOO")
          //   this.formcreateEngagementTaskProgress.text = ''
          //   this.formcreateEngagementTaskProgress.hoursSpent = 0
          //   this.formcreateEngagementTaskProgress.minutesSpent = 0
          //   this.formcreateEngagementTaskProgress.notifyProjectTeam = 0
          //   this.formcreateEngagementTaskProgress.notifyTaskTeam = 0
          //   this.formcreateEngagementTaskProgress.notifyClients = 0
          //   this.formcreateEngagementTaskProgress.notifyVendors = 0
          //   this.formcreateEngagementTaskProgress.reminderDate = ''
          //   this.formcreateEngagementTaskProgress.isReminderActive = false
          //   this.formcreateEngagementTaskProgress.timeSpent = '0000'
          // }
        },
      watch:{
        selectedRow(sed){
          console.log(sed)
          this.formcreateEngagementTaskProgress.progress = sed.progress
        },
        assignmentList(val) {
            this.formcreateEngagementTaskProgress.assignments = val
        },
      }
    };
</script>

<style lang="less" scoped>
    .text-block{
        display:flex;
        flex-direction:column;
    }
    .reminder-block{
        justify-content: space-between;
        display:flex;
        &_date{
            display:flex;
        }
    }
    .reminder-datepicker{
        margin-left:0;
    }
    .flex-end{
        display:flex;
        justify-content:flex-end;
    }
    .sweet-modal-overlay{
        z-index:1000;
    }
    .remider{
        margin-bottom:10px;
        display:flex;
        justify-content:flex-end;
    }
    .upload-media{
        display:flex;
        justify-content:flex-end;
    }
</style>
<style lang="less">
    .flex-twocolumn{
        display:flex;
        .el-form-item__content{
            margin:0 12px;
            font-size:13px;
        }
    }
    .reminder-block{
        .el-date-editor.el-input{
            width: 160px;
        }
    }
</style>
